import { FunctionComponent } from "react";
import Bikelogorectangle from "./Bikelogorectangle";

const LogoRectangle: FunctionComponent = () => {
  return (
    <div className="self-stretch flex flex-col items-start justify-start p-2.5 box-border max-w-full shrink-0">
      <Bikelogorectangle
        logo2="/logo1@2x.png"
        bikerider3="/bikerider2@2x.png"
      />
    </div>
  );
};

export default LogoRectangle;
